import {
    MarketplaceDepositApplicability,
    MarketplaceDepositCategory,
    MarketplaceDepositCategoryId,
    MarketplaceDepositRule,
    MarketplaceDepositType
} from '@spike/marketplace-model';
import { ValueTypeSelectorValue } from 'components/UI/V3/Forms/ValueTypeSelector';

export type DepositApplicability = MarketplaceDepositApplicability;

export type DepositCategoryId = MarketplaceDepositCategoryId;

export type DepositCategoryValues = Partial<Record<DepositCategoryId, ValueTypeSelectorValue>>;

export const DEFAULT_DEPOSIT_CATEGORY_VALUE: ValueTypeSelectorValue = {
    type: 'amount',
    value: 0
};

export const toValueTypeSelectorValue = (type: MarketplaceDepositType, value?: string): ValueTypeSelectorValue => ({
    type: type === MarketplaceDepositType.Percentage ? 'percentage' : 'amount',
    value: Number(value ?? 0)
});

export const toDepositType = (value: ValueTypeSelectorValue): MarketplaceDepositType =>
    value.type === 'percentage' ? MarketplaceDepositType.Percentage : MarketplaceDepositType.Amount;

export const selectableRules = (
    rules: Array<MarketplaceDepositRule>,
    categories: Array<MarketplaceDepositCategory>
): Array<MarketplaceDepositRule> => rules.filter(rule => categories.some(category => category.id === rule.categoryId));

export const toSelectedCategories = (rules: Array<MarketplaceDepositRule>): Array<DepositCategoryId> =>
    rules.map(rule => rule.categoryId);

export const toCategoryValues = (rules: Array<MarketplaceDepositRule>): DepositCategoryValues =>
    rules.reduce(
        (values: DepositCategoryValues, rule) => ({
            ...values,
            [rule.categoryId]: toValueTypeSelectorValue(rule.type, rule.value)
        }),
        {}
    );

export const toDepositRules = (
    selected: Array<DepositCategoryId>,
    values: DepositCategoryValues
): Array<MarketplaceDepositRule> =>
    selected.map(categoryId => {
        const value = values[categoryId] ?? DEFAULT_DEPOSIT_CATEGORY_VALUE;

        return {
            categoryId,
            type: toDepositType(value),
            value: value.value.toString()
        };
    });
